import {MacOSCursor} from '@remotion/mac-cursors';
import {Video} from '@remotion/media';
import {AbsoluteFill, Easing, interpolate, useCurrentFrame} from 'remotion';

export const CaptionsRecordingComposition = () => {
	const frame = useCurrentFrame();

	return (
		<AbsoluteFill
			name="Canvas Capture"
			durationInFrames={612}
			style={{
				width: 1902,
				height: 1440,
			}}
		>
			<Video
				src="https://remotion.media/explore-remotion/captions-source-2026-10-20-0552682946b5.mp4"
				durationInFrames={612}
				style={{
					position: 'absolute',
				}}
			/>
			<MacOSCursor
				cursor={interpolate(
					frame,
					[12, 24, 25, 26, 92, 223, 230, 568, 569],
					[
						'auto',
						'row-resize',
						'auto',
						'default',
						'auto',
						'row-resize',
						'auto',
						'row-resize',
						'auto',
					],
					{
						easing: Easing.step1,
						extrapolateLeft: 'clamp',
						extrapolateRight: 'clamp',
					},
				)}
				style={{
					position: 'absolute',
					left: 0,
					top: 0,
					scale: interpolate(
						frame,
						[0, 76, 82, 605, 611],
						[
							2.536606847957723, 2.282946163161951, 2.536606847957723,
							2.282946163161951, 2.536606847957723,
						],
						{
							easing: Easing.step1,
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
					translate: interpolate(
						frame,
						[
							12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27,
							28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 40, 41, 43, 44, 45,
							46, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102,
							103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115,
							116, 126, 127, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137,
							138, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149, 150, 151,
							152, 153, 154, 155, 156, 157, 158, 159, 160, 161, 162, 163, 164,
							165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 207, 208, 209,
							210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222,
							223, 224, 225, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236,
							237, 238, 239, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250,
							561, 562, 563, 564, 565, 566, 567, 568, 569, 570, 571, 572, 573,
							574, 575, 576, 577, 578, 579, 580, 581, 582, 583, 584, 585, 586,
							587, 588, 589, 590, 591, 592, 593, 594, 595, 596, 597, 598, 599,
							600, 601, 603, 604, 605,
						],
						[
							'205.60387537157325px 1657.6428492788725px',
							'209.23043047451281px 1655.334140702411px',
							'221.09104921281514px 1641.7494219971375px',
							'226.42188704172628px 1636.3987669272267px',
							'233.19938346361332px 1626.2127050533963px',
							'237.9158868215347px 1618.444346581526px',
							'243.36562809644388px 1605.0974347682484px',
							'245.42662116040955px 1596.843553891886px',
							'255.88021578773532px 1558.140482219531px',
							'255.88021578773532px 1558.140482219531px',
							'255.88021578773532px 1515.533414070241px',
							'255.88021578773532px 1474.4126389959263px',
							'255.88021578773532px 1454.0008807662666px',
							'251.73841241880436px 1437.4931190135417px',
							'248.32984696686114px 1427.3070571397116px',
							'243.95023670593415px 1419.538698667841px',
							'242.61257293845645px 1411.7703401959704px',
							'241.64152812947262px 1408.1239678520312px',
							'240.6704833204888px 1406.1818782340636px',
							'238.89684025101838px 1404.4082351645932px',
							'238.89684025101838px 1403.4371903556093px',
							'236.95475063305074px 1402.4661455466255px',
							'235.98370582406693px 1400.5240559286578px',
							'235.98370582406693px 1400.5240559286578px',
							'235.11174722008147px 1398.7008697566882px',
							'234.14070241109764px 1398.7008697566882px',
							'234.14070241109764px 1397.9973577012px',
							'234.14070241109764px 1397.9973577012px',
							'233.45700759660903px 1397.9973577012px',
							'233.45700759660903px 1397.9973577012px',
							'232.78322140262026px 1397.9973577012px',
							'232.04998348563248px 1397.9973577012px',
							'231.3167455686447px 1398.7206869976878px',
							'231.3167455686447px 1398.7206869976878px',
							'231.92117141913462px 1398.7206869976878px',
							'252.31311240779476px 1398.7206869976878px',
							'304.3531872729274px 1402.6345920951226px',
							'339.59815039084003px 1418.3001211053615px',
							'477.57569085104035px 1461.9674116481337px',
							'571.8661235274689px 1493.1300231201144px',
							'650.035230650666px 1522.0334691181326px',
							'697.4281625013762px 1536.2027964328965px',
							'736.4086755477265px 1550.927006495651px',
							'748.556644280524px 1558.2098425630297px',
							'768.9485852691842px 1562.698447649455px',
							'781.7802488164702px 1569.1093251128482px',
							'789.5287900473411px 1570.80369921832px',
							'804.778156996587px 1572.4980733237917px',
							'814.9444016294176px 1572.4980733237917px',
							'831.4323461411427px 1572.4980733237917px',
							'844.7594407134206px 1572.4980733237917px',
							'861.2473852251459px 1572.4980733237917px',
							'874.5744797974237px 1574.5590663877572px',
							'887.9015743697016px 1578.3144335571947px',
							'898.0678190025321px 1581.7031817681382px',
							'903.3986568314433px 1584.358692062094px',
							'907.0252119343828px 1587.9852471650336px',
							'908.9474843113509px 1589.9075195420014px',
							'909.9086204998348px 1590.8686557304854px',
							'910.8697566883188px 1592.7909281074533px',
							'911.8308928768027px 1594.7132004844213px',
							'911.8308928768027px 1595.6743366729054px',
							'911.8308928768027px 1595.6743366729054px',
							'913.0991963007816px 1595.6743366729054px',
							'946.6894197952217px 1595.6743366729054px',
							'975.6325002752394px 1598.4685676538588px',
							'996.0244412638996px 1602.957172740284px',
							'1021.0635252669822px 1605.7514037212375px',
							'1050.0066057469999px 1610.9732467246504px',
							'1066.494550258725px 1615.0952328525816px',
							'1074.2430914895958px 1616.4229879995596px',
							'1077.8696465925354px 1616.4229879995596px',
							'1080.535065506991px 1617.7507431465374px',
							'1082.4573378839589px 1617.7507431465374px',
							'1082.4573378839589px 1618.4740724430253px',
							'1082.4573378839589px 1618.4740724430253px',
							'1082.4573378839589px 1619.1280413960144px',
							'1082.4573378839589px 1619.9207310360011px',
							'1082.4573378839589px 1619.9207310360011px',
							'1082.4573378839589px 1622.635693052956px',
							'1082.4573378839589px 1624.557965429924px',
							'1082.4573378839589px 1626.4802378068919px',
							'1083.418474072443px 1628.40251018386px',
							'1083.418474072443px 1630.3247825608278px',
							'1084.379610260927px 1631.2859187493118px',
							'1085.1722999009137px 1633.0397445777826px',
							'1087.0945722778818px 1634.0008807662666px',
							'1089.0168446548496px 1634.9620169547504px',
							'1096.7653858857204px 1636.6563910602224px',
							'1106.9316305185512px 1640.045139271166px',
							'1120.2587250908289px 1642.1061323351314px',
							'1136.7466696025542px 1642.1061323351314px',
							'1153.2346141142793px 1642.1061323351314px',
							'1169.7225586260045px 1642.1061323351314px',
							'1186.2105031377298px 1642.1061323351314px',
							'1196.3767477705603px 1642.1061323351314px',
							'1206.5429924033908px 1642.1061323351314px',
							'1216.7092370362213px 1638.707475503688px',
							'1221.7923593526368px 1637.0031927777165px',
							'1234.624022899923px 1628.8682153473521px',
							'1244.7902675327534px 1622.0709016844653px',
							'1252.5388087636243px 1617.6912914235384px',
							'1265.3704723109104px 1609.9130243311681px',
							'1273.1190135417812px 1605.176703732247px',
							'1278.4498513706924px 1599.8260486623362px',
							'1282.076406473632px 1597.5173400858746px',
							'1285.7029615765716px 1595.2086315094132px',
							'1286.6640977650554px 1594.2375867004293px',
							'1289.5475063305075px 1593.2665418914455px',
							'1289.5475063305075px 1592.2954970824617px',
							'1289.5475063305075px 1592.2954970824617px',
							'1289.5475063305075px 1589.0058350765164px',
							'1292.569635582957px 1581.237476604646px',
							'1297.2861389408786px 1573.4691181327755px',
							'1302.7358802157876px 1560.1222063194978px',
							'1306.857866343719px 1551.8683254431355px',
							'1316.0629747880655px 1533.4283826929427px',
							'1321.1460971044808px 1523.2423208191126px',
							'1324.1682263569305px 1515.473962347242px',
							'1327.19035560938px 1507.7056038753715px',
							'1330.2124848618298px 1499.937245403501px',
							'1333.2346141142793px 1492.1688869316304px',
							'1336.2567433667289px 1484.40052845976px',
							'1339.2788726191786px 1476.6321699878895px',
							'1344.3619949355939px 1466.4461081140591px',
							'1347.3841241880434px 1458.6777496421887px',
							'1349.6730155235055px 1455.0313772982495px',
							'1351.5952879004733px 1453.0892876802818px',
							'1351.5952879004733px 1452.286689419795px',
							'1351.5952879004733px 1452.286689419795px',
							'1352.2591654739622px 1451.3156446108112px',
							'1354.5480568094242px 1447.669272266872px',
							'1357.2035671033798px 1442.3186171969612px',
							'1362.286689419795px 1432.132555323131px',
							'1369.79742375867px 1418.7856435098536px',
							'1381.2022459539799px 1400.8014973026532px',
							'1387.9797423758669px 1390.615435428823px',
							'1394.033909501266px 1382.8470769569524px',
							'1396.3228008367278px 1379.2007046130132px',
							'1398.2450732136958px 1377.2586149950457px',
							'1399.2062094021799px 1377.2586149950457px',
							'1399.2062094021799px 1376.456016734559px',
							'1399.2062094021799px 1376.456016734559px',
							'1400.167345590664px 1375.79213916107px',
							'1400.167345590664px 1374.8210943520862px',
							'1402.4562369261257px 1370.2036771991632px',
							'1405.1117472200815px 1364.8530221292524px',
							'1407.4006385555433px 1361.2066497853132px',
							'1409.6895298910051px 1357.560277441374px',
							'1411.611802267973px 1355.6181878234063px',
							'1412.572938456457px 1354.6471430144225px',
							'1412.572938456457px 1353.844544753936px',
							'1412.572938456457px 1353.844544753936px',
							'1398.6116921721898px 1355.9055378179014px',
							'1369.6487944511725px 1363.9315204227678px',
							'1330.6484641638224px 1373.0573599031156px',
							'1280.104590994165px 1386.473632059892px',
							'1223.4074644941097px 1404.1803368930969px',
							'1166.7103379940547px 1421.8870417263017px',
							'1116.166464824397px 1445.5587361004073px',
							'1052.5630298359572px 1471.8463062864691px',
							'923.760871958604px 1519.0410657271825px',
							'829.4506220411757px 1554.8805460750852px',
							'743.5825167896069px 1580.623142133656px',
							'665.39359242541px 1605.236155455246px',
							'608.696465925355px 1619.4054827700097px',
							'574.3432786524276px 1628.1647032918638px',
							'545.3803809314103px 1633.3865462952767px',
							'533.2225035781129px 1635.8141583177364px',
							'500.65286799515576px 1642.730375426621px',
							'484.14510624243087px 1644.7913684905868px',
							'463.7333480127711px 1646.8523615545523px',
							'443.3215897831113px 1646.8523615545523px',
							'426.8138280303864px 1646.8523615545523px',
							'413.46691621710886px 1648.546735660024px',
							'400.12000440383133px 1650.2411097654958px',
							'383.61224265110644px 1652.3021028294615px',
							'367.10448089838155px 1652.3021028294615px',
							'353.757569085104px 1652.3021028294615px',
							'340.4106572718265px 1652.3021028294615px',
							'330.2245953979962px 1652.3021028294615px',
							'320.038533524166px 1652.3021028294615px',
							'309.85247165033576px 1652.3021028294615px',
							'288.2516789606958px 1652.3021028294615px',
							'283.1586480237807px 1650.59782010349px',
							'267.8795552130353px 1648.8935373775184px',
							'257.6934933392051px 1648.8935373775184px',
							'244.34658152592755px 1648.8935373775184px',
							'234.16051965209732px 1648.8935373775184px',
							'223.97445777826707px 1648.8935373775184px',
							'221.29913024331168px 1648.8935373775184px',
							'221.29913024331168px 1648.8935373775184px',
							'209.62677529450622px 1648.8935373775184px',
							'209.62677529450622px 1648.8935373775184px',
							'203.06726852361552px 1648.8935373775184px',
							'202.65110646262247px 1648.8935373775184px',
						],
						{
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
				}}
			/>
		</AbsoluteFill>
	);
};
